import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.3026 13.2875C13.1158 13.4747 12.8621 13.58 12.5976 13.58C12.3331 13.58 12.0794 13.4747 11.8926 13.2875L7.0026 8.40748L2.1126 13.2975C1.92576 13.4847 1.67211 13.59 1.4076 13.59C1.14308 13.59 0.889427 13.4847 0.702595 13.2975C0.312595 12.9075 0.312595 12.2775 0.702595 11.8875L5.5926 6.99748L0.702595 2.10748C0.312595 1.71748 0.312595 1.08748 0.702595 0.697481C1.0926 0.307481 1.7226 0.307481 2.1126 0.697481L7.0026 5.58748L11.8926 0.697481C12.2826 0.307481 12.9126 0.307481 13.3026 0.697481C13.6926 1.08748 13.6926 1.71748 13.3026 2.10748L8.4126 6.99748L13.3026 11.8875C13.6826 12.2675 13.6826 12.9075 13.3026 13.2875Z" })
});
export { SvgClose as ReactComponent };
